'use client'

import React from 'react'
import { CompanySectionKey } from './CompanySidebar'
import { RebuildNotice } from './RebuildNotice'
import RegionsList from './entities/RegionsList'
import DepartmentsList from './entities/DepartmentsList'
import QuoteSourcesList from './entities/QuoteSourcesList'
import ClientTypesList from './entities/ClientTypesList'
import EntityRatingsList from './entities/EntityRatingsList'
import RefusalReasonsList from './entities/RefusalReasonsList'
import ContactPositionsList from './entities/ContactPositionsList'
import RolesList from './entities/RolesList'
import ContactsList from './entities/ContactsList'
import DriversList from './entities/DriversList'
import VehiclesList from './entities/VehiclesList'
import CarriersList from './entities/CarriersList'
import ClientsList from './entities/ClientsList'
import OrdersList from './entities/OrdersList'
import CargosList from './entities/CargosList'
import AddressesList from './entities/AddressesList'
import QuotesList from './entities/QuotesList'
import CompanyUsersList from './entities/CompanyUsersList'
import CompanySessionsList from './entities/CompanySessionsList'
import ActivityLogSection from './entities/ActivityLogSection'
import AuditLogSection from './entities/AuditLogSection'

export default function CompanyDetailView({
  company,
  activeSection,
}: {
  company: { id: string; name: string }
  activeSection: CompanySectionKey
}) {
  return <>{renderSection(activeSection, company.id)}</>
}

function renderSection(active: CompanySectionKey, companyId: string) {
  switch (active) {
    case 'users':              return <CompanyUsersList companyId={companyId} />
    case 'sessions':           return <CompanySessionsList companyId={companyId} />
    case 'regions':            return <RegionsList companyId={companyId} />
    case 'departments':        return <DepartmentsList companyId={companyId} />
    case 'quoteSources':       return <QuoteSourcesList companyId={companyId} />
    case 'clientTypes':        return <ClientTypesList companyId={companyId} />
    case 'entityRatings':      return <EntityRatingsList companyId={companyId} />
    case 'refusalReasons':     return <RefusalReasonsList companyId={companyId} />
    case 'contactPositions':   return <ContactPositionsList companyId={companyId} />
    case 'roles':              return <RolesList />
    case 'contacts':           return <ContactsList companyId={companyId} />
    case 'drivers':            return <DriversList companyId={companyId} />
    case 'vehicles':           return <VehiclesList companyId={companyId} />
    case 'carriers':           return <CarriersList companyId={companyId} />
    case 'clients':            return <ClientsList companyId={companyId} />
    case 'orders':             return <OrdersList companyId={companyId} />
    case 'cargos':             return <CargosList companyId={companyId} />
    case 'addresses':          return <AddressesList companyId={companyId} />
    case 'quotes':             return <QuotesList companyId={companyId} />
    case 'activityLog':        return <ActivityLogSection companyId={companyId} />
    case 'auditLog':           return <AuditLogSection companyId={companyId} />
    default:                   return <RebuildNotice title={String(active)} />
  }
}
